import type { RouteDefinition } from '../shared/router/router';

// Карта маршрутов SPA (docs/scenarios.md, «Разделы интерфейса»).
export type RouteKey =
  | 'home'
  | 'login'
  | 'register'
  | 'blogs'
  | 'posts'
  | 'post'
  | 'media'
  | 'mediaItem'
  | 'entities'
  | 'entity'
  | 'queue'
  | 'calendar'
  | 'due'
  | 'publication'
  | 'settings'
  | 'tasks'
  | 'task'
  | 'adminOverview'
  | 'adminBlogs'
  | 'adminOnline'
  | 'adminSettings'
  | 'adminUsers'
  | 'adminApiKeys'
  | 'adminPlans'
  | 'adminTasks'
  | 'adminBackups'
  | 'profile';

export const ROUTES: readonly RouteDefinition<RouteKey>[] = [
  { key: 'home', pattern: '/' },
  { key: 'login', pattern: '/login' },
  { key: 'register', pattern: '/register' },
  { key: 'blogs', pattern: '/blogs' },
  { key: 'posts', pattern: '/b/:blogId/posts' },
  { key: 'post', pattern: '/b/:blogId/posts/:postId' },
  { key: 'media', pattern: '/b/:blogId/media' },
  { key: 'mediaItem', pattern: '/b/:blogId/media/:mediaId' },
  { key: 'entities', pattern: '/b/:blogId/entities/:typeId' },
  { key: 'entity', pattern: '/b/:blogId/entities/:typeId/:entityId' },
  { key: 'queue', pattern: '/b/:blogId/queue' },
  { key: 'calendar', pattern: '/b/:blogId/calendar' },
  { key: 'due', pattern: '/b/:blogId/due' },
  { key: 'publication', pattern: '/b/:blogId/publications/:publicationId' },
  { key: 'settings', pattern: '/b/:blogId/settings/:section' },
  { key: 'tasks', pattern: '/b/:blogId/tasks' },
  { key: 'task', pattern: '/b/:blogId/tasks/:taskId' },
  { key: 'adminOverview', pattern: '/admin/overview' },
  { key: 'adminBlogs', pattern: '/admin/blogs' },
  { key: 'adminOnline', pattern: '/admin/online' },
  { key: 'adminSettings', pattern: '/admin/settings' },
  { key: 'adminUsers', pattern: '/admin/users' },
  { key: 'adminApiKeys', pattern: '/admin/api-keys' },
  { key: 'adminPlans', pattern: '/admin/plans' },
  { key: 'adminTasks', pattern: '/admin/tasks' },
  { key: 'adminBackups', pattern: '/admin/backups' },
  { key: 'profile', pattern: '/profile' },
];

export const BLOG_ROUTES: readonly RouteKey[] = ['posts', 'post', 'media', 'mediaItem', 'entities', 'entity', 'queue', 'calendar', 'due', 'publication', 'settings', 'tasks', 'task'];

export enum SettingsSection {
  Blog = 'blog',
  Members = 'members',
  Channels = 'channels',
  Schemes = 'schemes',
  Statuses = 'statuses',
  PostFormats = 'post-formats',
  EntityTypes = 'entity-types',
  PostFields = 'post-fields',
  MediaTraffic = 'media-traffic',
  MediaStorage = 'media-storage',
  /** TASK-UC-3: фоновые задачи блога. */
  Tasks = 'tasks',
}
